import { withRouter } from 'react-router';

export const bindRouter = withRouter as any;
